export default "__VITE_ASSET__DdQk61uC__"